import { render, staticRenderFns } from "./asinChangeModal.vue?vue&type=template&id=5062a05c"
import script from "./asinChangeModal.vue?vue&type=script&lang=js"
export * from "./asinChangeModal.vue?vue&type=script&lang=js"
import style0 from "./asinChangeModal.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports